import { getI18nService } from '@rendora/common/services/i18n';
import { ORDER_TYPE } from '@rendora/common/types/enums';
import { usePayment } from '../../store';
import { showPaymentModal } from '../pay-modal';
import BuyStorage from './BuyStorage.vue';

const buyStorageSymbol = Symbol('buyStorage');

export const showBuyStorageModal = async () => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  try {
    // 检查购买限制
    const paymentStore = usePayment();
    await paymentStore.checkPurchaseLimit(ORDER_TYPE.STORAGE);

    showPaymentModal(<BuyStorage />, { title: $t('jia-gou-cun-chu') }, buyStorageSymbol);
  } catch (err) {
    //
  }
};
